import { Button } from "@design-system/Inputs/Button";
import { FlexCol } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type FC, type PropsWithChildren, type ReactNode } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { useErrorBoundaryTranslations } from "./i18n";
import { addReactError } from "@app/datadog";

const DefaultFallback: FC = () => {
    const { t, keys } = useErrorBoundaryTranslations();

    const reloadPage = () => window.location.reload();

    return (
        <FlexCol
            className="border justify-center items-center"
            h="full"
            w="full"
            gap="4"
        >
            <Text variant="header1">{t(keys.error)}</Text>
            <Text variant="body-bold">{t(keys.errorDescription)}</Text>
            <Button onClick={reloadPage}>{t(keys.reloadPage)}</Button>
        </FlexCol>
    );
};

const ErrorBoundary: FC<
    PropsWithChildren<{
        fallback?: ReactNode;
    }>
> = ({ children, fallback }) => {
    return (
        <ReactErrorBoundary
            fallback={fallback ?? <DefaultFallback />}
            onError={addReactError}
        >
            {children}
        </ReactErrorBoundary>
    );
};

export default ErrorBoundary;
